import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { useSelector } from 'react-redux';
import ExtraCard from '../Components/ExtraCard.jsx';
import '../CSS/schoolfee.css';
import FeeIcon from '../img/schoolfee.gif';
import { schoolFeeAPI } from '../services/api';
import { Modal, Button, Toast, ToastContainer} from 'react-bootstrap';
import { CheckCircleFill, ExclamationTriangleFill, PencilSquare, Trash, Gear, Eye, BarChartFill } from 'react-bootstrap-icons';
import SchoolFeeGuideModal from '../Components/SchoolFeeGuideModal.jsx';
import SchoolFeeAmounts from '../Components/SchoolFeeAmounts';
import FeeExport from '../Components/FeeExport';
import FeeDocumentManager from '../Components/FeeDocumentManager';

function SchoolFee() {
  const [totals, setTotals] = useState({
    schoolFee: { total_fee: 0, total_paid: 0, total_outstanding: 0 },
    miscFee: { total_fee: 0, total_paid: 0, total_outstanding: 0 }
  });
  
  const [submittedRecordsSort, setSubmittedRecordsSort] = useState({
  field: 's.studentName', // Default sort field
  direction: 'ASC'       // Default sort direction
});
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [showStatistics, setShowStatistics] = useState(false);
  const { user } = useSelector(state => state.auth);
  const userRole = user?.role || '';
  const [students, setStudents] = useState([]);
  const [feeData, setFeeData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [submittedFees, setSubmittedFees] = useState([]);
  const [isLoadingSubmitted, setIsLoadingSubmitted] = useState(true);
  const [expandedRecords, setExpandedRecords] = useState({});
  
  const [filterName, setFilterName] = useState('');
  const [filterClass, setFilterClass] = useState('');
  const [showPagination, setShowPagination] = useState(true);
 
  
  const [toast, setToast] = useState({
    show: false,
    message: '',
    variant: 'success'
  });
  const [newEntriesFilterName, setNewEntriesFilterName] = useState('');
  const [newEntriesFilterClass, setNewEntriesFilterClass] = useState('');
  const [editingSchoolFee, setEditingSchoolFee] = useState(null);
  const [editingMiscFee, setEditingMiscFee] = useState(null);
  const [isFeeAmountsLoading, setIsFeeAmountsLoading] = useState(true); 
  const [feeAmounts, setFeeAmounts] = useState({});  
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [showFeeAmountsModal, setShowFeeAmountsModal] = useState(false); 
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    type: '',
    id: null,
    studentName: ''
  });
  // Print feature state
const [showPrintModal, setShowPrintModal]         = useState(false);
const [printPassword, setPrintPassword]           = useState('');
const [printPasswordError, setPrintPasswordError] = useState('');
const [isPrintVerifying, setIsPrintVerifying]     = useState(false);
const [printClass, setPrintClass]                 = useState('');
const [showPrintPassword, setShowPrintPassword]   = useState(false);
const [printMode, setPrintMode] = useState('full'); // 'full' | 'schoolFeeOnly'

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending'
  });
  const [newEntriesSortConfig, setNewEntriesSortConfig] = useState({
    key: null,
    direction: 'ascending'
  });
  const [pagination, setPagination] = useState({
    submittedFees: {
      currentPage: 1,
      itemsPerPage: 10,
      totalItems: 0,
      totalPages: 1
    },
    newEntries: {
      currentPage: 1,
      itemsPerPage: 10,
      totalItems: 0,
      totalPages: 1
    }
  });

  const handleDocumentActionRef = React.useRef(null);
const fetchPaymentHistoryRef = React.useRef(null);

const handleManagerReady = (docActionFn, paymentHistoryFn) => {
  handleDocumentActionRef.current = docActionFn;
  fetchPaymentHistoryRef.current = paymentHistoryFn;
};
  

const toggleRecordExpand = (studentId) => {
  setExpandedRecords(prev => ({ ...prev, [studentId]: !prev[studentId] }));
};

     // Initial data fetch with sorting
 // Load fee amounts first, then load students
// Load data in sequence
/*useEffect(() => {
  const loadData = async () => {
    console.log('Starting initial data load...');
    await fetchFeeAmounts();
    console.log('Fee amounts loaded, now loading other data...');
    // Small delay to ensure state is updated
    setTimeout(() => {
      fetchSubmittedFees(1, '', '', submittedRecordsSort.field, submittedRecordsSort.direction);
      fetchNewEntries(pagination.newEntries.currentPage);
    }, 100);
  };
  loadData();
}, []);*/

// Refresh new entries when feeAmounts changes
/*useEffect(() => {
  if (Object.keys(feeAmounts).length > 0 && !isFeeAmountsLoading) {
    console.log('Fee amounts updated, refreshing new entries...');
    fetchNewEntries(pagination.newEntries.currentPage);
  }
}, [feeAmounts, isFeeAmountsLoading]);*/

    const handleSubmittedRecordsSort = (field) => {
  // Toggle direction if sorting the same field, otherwise default to ASC
  const direction = 
    submittedRecordsSort.field === field 
      ? submittedRecordsSort.direction === 'ASC' ? 'DESC' : 'ASC'
      : 'ASC';

  setSubmittedRecordsSort({ field, direction });
  
  // Trigger fetch with new sorting
  fetchSubmittedFees(1, filterName, filterClass, field, direction);
};
    
//sort for new fee entries table
  const requestSort = (key, isNewEntries = false, isDescending = false) => {
    if (isNewEntries) {
      setNewEntriesSortConfig({
        key,
        direction: isDescending ? 'descending' : 'ascending'
      });
    } else {
      setSortConfig({
        key,
        direction: isDescending ? 'descending' : 'ascending'
      });
    }
  };

  const sortData = (data, config) => {
    if (!config.key) return data;

    return [...data].sort((a, b) => {
      if (config.key === 'class') {
        const numA = parseInt(a.class.match(/\d+/)?.[0] || 0);
        const numB = parseInt(b.class.match(/\d+/)?.[0] || 0);
        
        if (numA < numB) {
          return config.direction === 'ascending' ? -1 : 1;
        }
        if (numA > numB) {
          return config.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      }
      else if (config.key === 'studentName') {
        const nameA = a.studentName.toLowerCase();
        const nameB = b.studentName.toLowerCase();
        
        if (nameA < nameB) {
          return config.direction === 'ascending' ? -1 : 1;
        }
        if (nameA > nameB) {
          return config.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      }
      return 0;
    });
  };

const formatNumber = (value) => {
    if (value === null || value === undefined || value === '') return '0.00';
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '0.00';
    return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };


// fetch fee amounts-new 
useEffect(() => {
  const loadData = async () => {
    await fetchFeeAmounts(selectedYear);
    await fetchNewEntries(1);
    await fetchSubmittedFees(1);
    await fetchTotals();
  };
  loadData();
}, [selectedYear]);


const fetchFeeAmounts = async (year = selectedYear) => {
  try {
    setIsFeeAmountsLoading(true);
    const response = await schoolFeeAPI.getFeeAmounts({ year });
    if (response.data.success) {
      const amountsMap = {};
      response.data.data.forEach(fee => {
        amountsMap[fee.class.toString()] = parseFloat(fee.amount);
      });
      setFeeAmounts(prev => ({ ...prev, [year]: amountsMap }));
    }
  } catch (error) {
    console.error('Error fetching fee amounts:', error);
  } finally {
    setIsFeeAmountsLoading(false);
  }
};

// useEffect to refetch fee amounts when the modal closes
useEffect(() => {
  if (!showFeeAmountsModal) {
    fetchFeeAmounts();
    fetchSubmittedFees(pagination.submittedFees.currentPage);
    fetchNewEntries(pagination.newEntries.currentPage);
  }
}, [showFeeAmountsModal]);

const getSchoolFeeByClass = (className, year = selectedYear) => {
  if (!className) return null;
  const classNum = className.toString().replace(/\D/g, '');
  const yearAmounts = feeAmounts[year] || {};
  const fee = yearAmounts[classNum];
  return fee !== undefined ? fee : null;
};

//  filter handlers
const handleNameFilterChange = (e) => {
  const value = e.target.value;
  setFilterName(value);
  
  // Always fetch from server when filter changes
  fetchSubmittedFees(1, value, filterClass);
};

const handleClassFilterChange = (e) => {
  const value = e.target.value;
  setFilterClass(value);
  
  // Always fetch from server when filter changes
  fetchSubmittedFees(1, filterName, value);
};


useEffect(() => {
  // Skip debounce if both filters are empty (already handled in handlers)
  if (filterName === '' && filterClass === '') return;

  const timer = setTimeout(() => {
    fetchSubmittedFees(1);
  }, 500); // 500ms debounce

  return () => clearTimeout(timer);
}, [filterName, filterClass]);

const fetchSubmittedFees = async (page = 1, name = filterName, cls = filterClass,  sortField = submittedRecordsSort.field,
  sortDirection = submittedRecordsSort.direction) => {
  try {
    setIsPageLoading(true);
    setIsLoadingSubmitted(true);
   const response = await schoolFeeAPI.getRecords({
  page,
  limit: pagination.submittedFees.itemsPerPage,
  name,
  class: cls,
  sortField,
  sortDirection,
  year: selectedYear
});
    
    setSubmittedFees(response.data.data);
    setPagination(prev => ({
      ...prev,
      submittedFees: {
        ...prev.submittedFees,
        totalItems: response.data.total,
        totalPages: response.data.totalPages,
        currentPage: page
      }
    }));
  } catch (error) {
    console.error('Error fetching submitted fees:', error);
  } finally {
    setIsLoadingSubmitted(false);
    setIsPageLoading(false);
  }
};

const fetchNewEntries = async (page = 1, name = newEntriesFilterName, cls = newEntriesFilterClass) => {
  try {
    setIsLoading(true);
    const fetchPage = (name || cls) ? 1 : page;
    
    const response = await schoolFeeAPI.getStudents({
      page,
      limit: pagination.newEntries.itemsPerPage,
      name,
      class: cls,
      year: selectedYear
    });

    const studentsData = response.data.data;
    setStudents(studentsData);

    // Wait a brief moment to ensure feeAmounts is loaded, or force reload if needed
if (!feeAmounts[selectedYear] || Object.keys(feeAmounts[selectedYear]).length === 0) {
      console.log('Fee amounts empty, fetching now...');
      await fetchFeeAmounts();
    } else {
      console.log('Fee amounts available:', feeAmounts);
    }

    const initialFeeData = studentsData.map(student => {
  const schoolFee = getSchoolFeeByClass(student.class, selectedYear);

      console.log(`Student ${student.studentName} (Class ${student.class}): Fee = ${schoolFee}, Fee Amounts:`, feeAmounts);

      const baseMiscFees = [
        { id: 1, name: 'SRC Fee', amount: 20, paid: '', outstanding: 20 },
        { id: 2, name: 'ID Fee', amount: 20, paid: '', outstanding: 20 },
        { id: 5, name: 'Uniform', amount: 100, paid: '', outstanding: 100 },
        { id: 6, name: 'Computing fee', amount: 240, paid: '', outstanding: 240 }
      ];

      const classNum = parseInt(student.class.replace(/\D/g, ''));
      const additionalFees = [];
      if (classNum === 10 || classNum === 12) {
        additionalFees.push(
          { id: 3, name: 'Gown Fee', amount: 50, paid: '', outstanding: 50 },
          { id: 4, name: 'Certificate processing fee', amount: 200, paid: '', outstanding: 200 }
        );
      }

      return {
    studentId: student.id,
    studentName: student.studentName,
    class: student.class,
    enrollmentStatus: student.enrollmentStatus || 'Currently Enrolled',
    academicYear: selectedYear,
    schoolFee: schoolFee,
    schoolFeePaid: '',
    outstandingSchoolFee: schoolFee,
    schoolFeePaymentDate: '', //new 
    miscFees: [...baseMiscFees, ...additionalFees]
      };
    });
    
    setFeeData(initialFeeData);
    setPagination(prev => ({
      ...prev,
      newEntries: {
        ...prev.newEntries,
        totalItems: response.data.total,
        totalPages: response.data.totalPages,
        currentPage: page
      }
    }));
    
  } catch (error) {
    console.error('Error fetching new entries:', error);
  } finally {
    setIsLoading(false);
    setIsPageLoading(false);
  }
}
  // Update your filter handlers to reset to page 1 when filtering
const handleNewEntriesNameFilter = (e) => {
  const value = e.target.value;
  setNewEntriesFilterName(value);
  fetchNewEntries(1, value, newEntriesFilterClass);
};

const handleNewEntriesClassFilter = (e) => {
  const value = e.target.value;
  setNewEntriesFilterClass(value);
  fetchNewEntries(1, newEntriesFilterName, value);
};
useEffect(() => {
  // Reset to page 1 when filters change
  if (newEntriesFilterName || newEntriesFilterClass) {
    setPagination(prev => ({
      ...prev,
      newEntries: {
        ...prev.newEntries,
        currentPage: 1
      }
    }));
  }
}, [newEntriesFilterName, newEntriesFilterClass]);
  /*const fetchData = async () => {
    try {
      await fetchNewEntries(pagination.newEntries.currentPage);
      await fetchSubmittedFees(pagination.submittedFees.currentPage);
      await fetchTotals();
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };*/

  const fetchTotals = async () => {
    try {
     const response = await schoolFeeAPI.getTotals({ year: selectedYear });
    if (response.data.success) {
      setTotals(response.data.data);
    }
    } catch (error) {
      console.error('Error fetching totals:', error);
    }
  };

 

  const handleSubmittedFeesPageChange = (newPage) => {
    setPagination(prev => ({
      ...prev,
      submittedFees: {
        ...prev.submittedFees,
        currentPage: newPage
      }
    }));
    fetchSubmittedFees(newPage);
  };

  const handleNewEntriesPageChange = (newPage) => {
    setPagination(prev => ({
      ...prev,
      newEntries: {
        ...prev.newEntries,
        currentPage: newPage
      }
    }));
    fetchNewEntries(newPage);
  };

  const handleFilterChange = (filterName, filterValue) => {
    if (filterName === 'name') {
      setNewEntriesFilterName(filterValue);
    } else if (filterName === 'class') {
      setNewEntriesFilterClass(filterValue);
    }
    
    // Reset to first page when filters change
    setPagination(prev => ({
      ...prev,
      newEntries: {
        ...prev.newEntries,
        currentPage: 1
      }
    }));
  };

 /* useEffect(() => {
    fetchData();
  }, []);*/

  useEffect(() => {
    fetchNewEntries(pagination.newEntries.currentPage);
  }, [newEntriesFilterName, newEntriesFilterClass]);

  const handleSchoolFeePaidChange = (studentId, value) => {
    const updatedData = feeData.map(student => {
      if (student.studentId === studentId) {
        const paidValue = value === '' ? '' : parseFloat(value);
        const outstanding = paidValue === '' ? student.schoolFee : student.schoolFee - paidValue;
        return {
          ...student,
          schoolFeePaid: paidValue,
          outstandingSchoolFee: outstanding
        };
      }
      return student;
    });
    setFeeData(updatedData);
  };

  const handleMiscFeePaidChange = (studentId, feeId, value) => {
    const updatedData = feeData.map(student => {
      if (student.studentId === studentId) {
        const updatedMiscFees = student.miscFees.map(fee => {
          if (fee.id === feeId) {
            const paidValue = value === '' ? '' : parseFloat(value);
            const outstanding = paidValue === '' ? fee.amount : fee.amount - paidValue;
            return {
              ...fee,
              paid: paidValue,
              outstanding: outstanding
            };
          }
          return fee;
        });
        return {
          ...student,
          miscFees: updatedMiscFees
        };
      }
      return student;
    });
    setFeeData(updatedData);
  };

  // add near handleSchoolFeeDateChange (line 514):
const handleAcademicYearChange = (studentId, value) => {
  const newYear = parseInt(value);

  // If this year's fee amounts aren't cached yet, fetch them
  if (!feeAmounts[newYear]) {
    fetchFeeAmounts(newYear);
  }

  const updatedData = feeData.map(student => {
    if (student.studentId === studentId) {
      const newSchoolFee = getSchoolFeeByClass(student.class, newYear);
      const paidValue = student.schoolFeePaid === '' ? '' : student.schoolFeePaid;
      const outstanding = paidValue === '' ? newSchoolFee : newSchoolFee - paidValue;
      return {
        ...student,
        academicYear: newYear,
        schoolFee: newSchoolFee,
        outstandingSchoolFee: outstanding
      };
    }
    return student;
  });
  setFeeData(updatedData);
};

  //  handler functions for payment dates
const handleSchoolFeeDateChange = (studentId, value) => {
  const updatedData = feeData.map(student => {
    if (student.studentId === studentId) {
      return {
        ...student,
        schoolFeePaymentDate: value
      };
    }
    return student;
  });
  setFeeData(updatedData);
};

const handleMiscFeeDateChange = (studentId, feeId, value) => {
  const updatedData = feeData.map(student => {
    if (student.studentId === studentId) {
      const updatedMiscFees = student.miscFees.map(fee => {
        if (fee.id === feeId) {
          return {
            ...fee,
            paymentDate: value
          };
        }
        return fee;
      });
      return {
        ...student,
        miscFees: updatedMiscFees
      };
    }
    return student;
  });
  setFeeData(updatedData);
};



  const handleSubmitStudentData = async (student) => {
    try {
      const filteredMiscFees = student.miscFees
        .filter(fee => fee.paid !== '' && parseFloat(fee.paid) > 0)
        .map(fee => ({
          name: fee.name,
          amount: fee.amount,
          paid: parseFloat(fee.paid),
          outstanding: fee.outstanding,
          paymentDate: fee.paymentDate //date for misc fees
        }));

      const hasSchoolFeePayment = student.schoolFeePaid !== '' && parseFloat(student.schoolFeePaid) > 0;
      const hasMiscFeePayments = filteredMiscFees.length > 0;

      if (!hasSchoolFeePayment && !hasMiscFeePayments) {
        showToastMessage('Please enter payment amount.', 'danger');
        return;
      }

      const response = await schoolFeeAPI.submitRecords({
  studentId: student.studentId,
academicYear: student.academicYear,
  schoolFee: student.schoolFee,
  schoolFeePaid: hasSchoolFeePayment ? parseFloat(student.schoolFeePaid) : 0,
  outstandingSchoolFee: student.outstandingSchoolFee,
  paymentDate: student.schoolFeePaymentDate || new Date().toISOString().split('T')[0],
  miscFees: filteredMiscFees
});
      
      if (response.data.success) {
        await new Promise(resolve => setTimeout(resolve, 500)); // 0.5 second delay
         // Clear inputs after successful submission
      setFeeData(prevData => 
        prevData.map(s => 
          s.studentId === student.studentId
            ? {
                ...s,
                schoolFeePaid: '',
                outstandingSchoolFee: s.schoolFee,
                schoolFeePaymentDate: '', // Clear date
                miscFees: s.miscFees.map(fee => ({
                  ...fee,
                  paid: '',
                  outstanding: fee.amount,
                  paymentDate: '' // Clear date
                }))
              }
            : s
        )
      );

        await fetchSubmittedFees(pagination.submittedFees.currentPage);
        await fetchTotals();
        
        showToastMessage(response.data.message === 'Partial success'
          ? `Submitted with some warnings for ${student.studentName}: ${response.data.errors.map(err => 
              err.replace(/student ID \d+/, `student ${student.studentName}`)
            ).join(', ')}`
          : response.data.message);
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      console.error('Submission error:', error);
      showToastMessage(`Error: ${error.response?.data?.message || error.message}`, 'danger');
    }
  };

  const handleSubmitAll = async () => {
    try {
      const studentIdToNameMap = {};
      feeData.forEach(student => {
        studentIdToNameMap[student.studentId] = student.studentName;
      });

      const payload = feeData
        .map(student => {
          const filteredMiscFees = student.miscFees
            .filter(fee => fee.paid !== '' && parseFloat(fee.paid) > 0)
            .map(fee => ({
              name: fee.name,
              amount: fee.amount,
              paid: parseFloat(fee.paid),
              outstanding: fee.outstanding,
              paymentDate: fee.paymentDate 
            }));

          const hasSchoolFeePayment = student.schoolFeePaid !== '' && parseFloat(student.schoolFeePaid) > 0;
          const hasMiscFeePayments = filteredMiscFees.length > 0;

         if (hasSchoolFeePayment || hasMiscFeePayments) {
            return {
              studentId: student.studentId,
              studentName: student.studentName,
             academicYear: student.academicYear,
              schoolFee: student.schoolFee,
              schoolFeePaid: hasSchoolFeePayment ? parseFloat(student.schoolFeePaid) : 0,
              outstandingSchoolFee: student.outstandingSchoolFee,
                paymentDate: student.schoolFeePaymentDate || new Date().toISOString().split('T')[0], // CHANGE: schoolFeePaymentDate ? paymentDate
              miscFees: filteredMiscFees
            };
          }
          return null;
        })
        .filter(student => student !== null);

      if (payload.length === 0) {
        showToastMessage('Please enter payment amounts.', 'danger');
        return;
      }

      const response = await schoolFeeAPI.submitRecords(payload);
      
      if (response.data.success) {

await new Promise(resolve => setTimeout(resolve, 500)); // 0.5 second delay
         // Clear all inputs after successful bulk submission
      setFeeData(prevData => 
        prevData.map(student => ({
          ...student,
          schoolFeePaid: '',
          outstandingSchoolFee: student.schoolFee,
          schoolFeePaymentDate: '', // Clear date
          miscFees: student.miscFees.map(fee => ({
            ...fee,
            paid: '',
            outstanding: fee.amount,
            paymentDate: '' // Clear date
          }))
        }))
      );

        await fetchSubmittedFees(pagination.submittedFees.currentPage);
        await fetchTotals();
        
        showToastMessage(response.data.message === 'Partial success'
          ? `Submitted with some warnings: ${response.data.errors.map(err => 
              err.replace(/student ID \d+/, match => {
                const studentId = match.match(/\d+/)[0];
                return `student ${studentIdToNameMap[studentId] || studentId}`;
              })
            ).join(', ')}`
          : response.data.message);
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      console.error('Bulk submission error:', error);
      showToastMessage(`Error: ${error.response?.data?.message || error.message}`, 'danger');
    }
  };



  
  const filteredSubmittedFees = sortData(
    submittedFees.filter(fee => {
      return (filterName === '' || fee.studentName.toLowerCase().includes(filterName.toLowerCase())) &&
             (filterClass === '' || fee.class === filterClass);
    }),
    sortConfig
  );

  const filteredFeeData = sortData(
    feeData.map(student => {
      const submittedRecord = submittedFees.find(
        record => record.student_id === student.studentId
      );
      
      return {
        ...student,
        enrollmentStatus: submittedRecord?.enrollmentStatus || student.enrollmentStatus
      };
    }),
    newEntriesSortConfig
  );


  const handleEditSchoolFee = (fee) => {
    setEditingSchoolFee(fee);
  };
  
  const handleEditMiscFee = (fee) => {
    setEditingMiscFee(fee);
  };

  const safeParseFloat = (value) => {
    if (value === '' || value === null || value === undefined) return null;
    const num = parseFloat(value);
    return isNaN(num) ? null : num;
  };

  const compareAmounts = (a, b) => {
    return Math.abs((a || 0) - (b || 0)) < 0.01;
  };

 const handleUpdateSchoolFee = async () => {
    try {
      if (!editingSchoolFee?.id) {
        throw new Error('No fee ID found for update');
      }

      const exact_paid = safeParseFloat(editingSchoolFee.exact_paid);
      if (exact_paid === null || exact_paid <= 0) {
        throw new Error('Invalid payment amount');
      }

      const response = await schoolFeeAPI.updateSchoolFee(editingSchoolFee.id, {
        exact_paid
      });

      if (response.data.success) {
        await fetchSubmittedFees(pagination.submittedFees.currentPage);
        setEditingSchoolFee(null);
        showToastMessage('School fee updated successfully');
        fetchTotals();
      }
    } catch (error) {
      console.error('Error updating school fee:', error);
      showToastMessage(`Error: ${error.response?.data?.message || error.message}`, 'danger');
    }
  };

 const handleUpdateMiscFee = async () => {
    try {
      if (!editingMiscFee?.id) {
        throw new Error('No fee ID found for update');
      }

      const exact_paid = safeParseFloat(editingMiscFee.exact_paid);
      if (exact_paid === null || exact_paid <= 0) {
        throw new Error('Invalid payment amount');
      }

      const response = await schoolFeeAPI.updateMiscFee(editingMiscFee.id, {
        exact_paid
      });

      if (response.data.success) {
        await fetchSubmittedFees(pagination.submittedFees.currentPage);
        setEditingMiscFee(null);
        showToastMessage('Miscellaneous fee updated successfully');
        fetchTotals();
      }
    } catch (error) {
      console.error('Error updating miscellaneous fee:', error);
      showToastMessage(`Error: ${error.response?.data?.message || error.message}`, 'danger');
    }
  };
  
  const showDeleteModal = (type, id, studentName) => {
    setDeleteModal({
      show: true,
      type,
      id,
      studentName
    });
  };
  
  const handleDeleteFee = async () => {
    try {
      if (!deleteModal.id) {
        throw new Error('No fee ID found for deletion');
      }
      
     const response = deleteModal.type === 'school' 
      ? await schoolFeeAPI.deleteSchoolFee(deleteModal.id)
      : await schoolFeeAPI.deleteMiscFee(deleteModal.id);

      if (response.data.success) {
        await fetchSubmittedFees(pagination.submittedFees.currentPage);
        setDeleteModal({ show: false, type: '', id: null, studentName: '' });
        showToastMessage(`${deleteModal.type === 'school' ? 'School' : 'Miscellaneous'} fee deleted successfully`);
        fetchTotals();
      }
    } catch (error) {
      console.error('Error deleting fee:', error);
      showToastMessage(`Error: ${error.response?.data?.message || error.message}`, 'danger');
    }
  };

  const showToastMessage = (message, variant = 'success') => {
    setToast({
      show: true,
      message,
      variant
    });
    
    setTimeout(() => {
      setToast(prev => ({ ...prev, show: false }));
    }, 3000);
  };

  // ─── Print Handlers ───────────────────────────────────────────────────────────

const handlePrintClick = (mode = 'full') => {
  setPrintMode(mode);
  setPrintClass(filterClass || '');
  setPrintPassword('');
  setPrintPasswordError('');
  setShowPrintPassword(false);
  setShowPrintModal(true);
};

const handlePrintVerify = async () => {
  if (!printClass) {
    setPrintPasswordError('Please select a class to print.');
    return;
  }
  if (!printPassword) {
    setPrintPasswordError('Password is required.');
    return;
  }

  setIsPrintVerifying(true);
  setPrintPasswordError('');

  try {
    const verifyRes = await fetch('/api/schoolfee/verify-print-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password: printPassword }),
    });
    const verifyData = await verifyRes.json();

    if (!verifyData.success) {
      setPrintPasswordError('Incorrect password. Please try again.');
      setPrintPassword('');
      return;
    }

    // Fetch records for selected class — endpoint depends on print mode
    const endpoint = printMode === 'schoolFeeOnly'
      ? `/api/schoolfee/print-school-fee-only/${printClass}`
      : `/api/schoolfee/print-records/${printClass}`;

    const recordsRes = await fetch(endpoint);
    const recordsData = await recordsRes.json();

    if (!recordsData.success) {
      setPrintPasswordError('Failed to load records. Please try again.');
      return;
    }

    setShowPrintModal(false);
    setTimeout(() => {
      if (printMode === 'schoolFeeOnly') {
        executePrintSchoolFeeOnly(printClass, recordsData.data);
      } else {
        executePrint(printClass, recordsData.data, feeAmounts);
      }
    }, 150);

  } catch (err) {
    setPrintPasswordError('An error occurred. Please try again.');
  } finally {
    setIsPrintVerifying(false);
    setPrintPassword('');
    setShowPrintPassword(false);
  }
};


const executePrintSchoolFeeOnly = (selectedClass, records) => {
  const printWindow = window.open('', '_blank');
  const html = buildSchoolFeeOnlyPrintHTML(selectedClass, records);
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
};

const buildSchoolFeeOnlyPrintHTML = (selectedClass, records) => {
  const printDate = formatPrintDate(new Date().toISOString());
  const fmt = n => parseFloat(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const rows = records.map(r => `
    <tr>
      <td>${r.studentIdNumber ?? '—'}</td>
      <td>${r.studentName}</td>
      <td>${r.gender ?? '—'}</td>
      <td class="sf-print-paid">K${fmt(r.paid)}</td>
      <td class="sf-print-outstanding">K${fmt(r.outstanding)}</td>
    </tr>`).join('');

  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>School Fee Records — Grade ${selectedClass}</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
    body { font-family: Arial, sans-serif; font-size: 11px; color: #111; padding: 12mm; background: white; }
    .sf-print-report-header { text-align: center; border-bottom: 2px solid #0a192f; padding-bottom: 10px; margin-bottom: 16px; }
    .sf-print-report-title { font-size: 18px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; color: #0a192f; }
    .sf-print-report-sub { font-size: 12px; color: #555; }
    table { width: 100%; border-collapse: collapse; margin-top: 6mm; }
    th { background: #0a192f; color: #00f2fe; font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; padding: 8px 10px; text-align: left; }
    td { padding: 6px 10px; font-size: 11px; border-bottom: 1px solid #eee; }
    tr:nth-child(even) td { background: #f9f9f9; }
    .sf-print-paid { color: #27ae60; font-weight: 600; }
    .sf-print-outstanding { color: #e74c3c; font-weight: 600; }
    .sf-print-footer { margin-top: 10mm; border-top: 1px solid #ccc; padding-top: 6px; font-size: 9px; color: #888; display: flex; justify-content: space-between; }
    @page { size: A4; margin: 0; }
  </style>
</head>
<body>
  <div class="sf-print-report-header">
    <div class="sf-print-report-title">Eastern Pacific Academy — School Fee Records</div>
    <div class="sf-print-report-sub">Grade ${selectedClass} &nbsp;|&nbsp; Printed: ${printDate} &nbsp;|&nbsp; Total Students: ${records.length}</div>
  </div>
  <table>
    <thead>
      <tr><th>ID Number</th><th>Student Name</th><th>Gender</th><th>School Fee Paid</th><th>School Fee Outstanding</th></tr>
    </thead>
    <tbody>${rows}</tbody>
  </table>
  <div class="sf-print-footer">
    <span>EPA School Management System</span>
    <span>Confidential — Admin Use Only</span>
  </div>
</body>
</html>`;
};

const executePrint = (selectedClass, records, feeAmounts) => {
  const printWindow = window.open('', '_blank');
  const html = buildPrintHTML(selectedClass, records, feeAmounts);
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
};



const formatPrintDate = (dateStr) => {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  if (isNaN(date)) return '—';
  const day = date.getDate();
  const month = date.toLocaleString('en-GB', { month: 'long' });
  const year = date.getFullYear();
  const suffix =
    day % 10 === 1 && day !== 11 ? 'st' :
    day % 10 === 2 && day !== 12 ? 'nd' :
    day % 10 === 3 && day !== 13 ? 'rd' : 'th';
  return `${day}${suffix} ${month}, ${year}`;
};

const buildPrintHTML = (selectedClass, records, feeAmounts = {}) => {
  const printDate = formatPrintDate(new Date().toISOString());

  const cards = records.map(student => {

    // School fee payment history rows
    const schoolFeeRows = student.schoolFees.length > 0
      ? student.schoolFees.map((sf, idx) => {
          const isLatest = idx === student.schoolFees.length - 1;
          const outstandingLabel = isLatest ? 'Current Outstanding' : 'Outstanding';
          const outstandingClass = isLatest ? 'sf-print-outstanding' : 'sf-print-outstanding-old';
          return `
            <div class="sf-print-history-entry">
              <span class="sf-print-history-date">${formatPrintDate(sf.payment_date)}</span>
              &nbsp;—&nbsp;
              Paid: <span class="sf-print-paid">K${parseFloat(sf.exact_paid).toFixed(2)}</span>
              &nbsp;|&nbsp;
              ${outstandingLabel}: <span class="${outstandingClass}">K${parseFloat(sf.outstanding).toFixed(2)}</span>
              &nbsp;|&nbsp;
              Fee: K${parseFloat(sf.fee_amount).toFixed(2)}
            </div>`;
        }).join('')
      : '<div style="color:#aaa;font-size:10px;padding:4px 0;">No school fee payments recorded.</div>';

    // Group misc fees by name, show all payments per fee name
    const miscGrouped = student.miscFees.reduce((acc, mf) => {
      if (!acc[mf.name]) acc[mf.name] = [];
      acc[mf.name].push(mf);
      return acc;
    }, {});

    const miscRows = Object.keys(miscGrouped).length > 0
      ? Object.entries(miscGrouped).map(([name, payments]) => {
          const latest = payments[payments.length - 1];
          const historyRows = payments.map((p, pidx) => {
            const isLatest = pidx === payments.length - 1;
            const outstandingLabel = isLatest ? 'Current Outstanding' : 'Outstanding';
            const outstandingClass = isLatest ? 'sf-print-outstanding' : 'sf-print-outstanding-old';
            return `
              <div class="sf-print-history-entry">
                <span class="sf-print-history-date">${formatPrintDate(p.payment_date)}</span>
                &nbsp;—&nbsp;
                Paid: <span class="sf-print-paid">K${parseFloat(p.exact_paid).toFixed(2)}</span>
                &nbsp;|&nbsp;
                ${outstandingLabel}: <span class="${outstandingClass}">K${parseFloat(p.outstanding).toFixed(2)}</span>
              </div>`;
          }).join('');
          return `
            <div class="sf-print-section-label">${name} — K${parseFloat(latest.amount).toFixed(2)}</div>
            ${historyRows}`;
        }).join('')
      : '<div style="color:#aaa;font-size:10px;padding:4px 0;">No miscellaneous fees recorded.</div>';

    const latestEnrollment = student.schoolFees.length > 0
      ? student.schoolFees[student.schoolFees.length - 1].enrollmentStatus
      : 'Currently Enrolled';

    return `
      <div class="sf-print-card">
        <div class="sf-print-card-header">
          <span class="sf-print-card-name">${student.studentName}</span>
          <span class="sf-print-card-meta">Grade ${student.class} &nbsp;|&nbsp; ${latestEnrollment}</span>
        </div>
        <div class="sf-print-card-body">
          <div class="sf-print-section-label">School Fee History</div>
          ${schoolFeeRows}
          <div class="sf-print-section-label" style="margin-top:8px;">Miscellaneous Fees</div>
          ${miscRows}
        </div>
      </div>`;
  }).join('');

// ── Class Totals (includes ALL students, even zero-payment ones) ──────────
const baseMiscFeeTotal = (cls) => {
  const classNum = parseInt(String(cls).replace(/\D/g, ''));
  // Base fees: SRC(20) + ID(20) + Uniform(100) + Computing(240) = 380
  // Grade 10 & 12 add Gown(50) + Certificate(200) = 630
  return (classNum === 10 || classNum === 12) ? 630 : 380;
};

const classTotals = records.reduce(
  (acc, student) => {
    const classKey = String(student.class).replace(/\D/g, '');

    if (student.schoolFees.length > 0) {
      // Student has payment records — use the fee_amount from their latest record
      // and sum exact payments; outstanding comes from the last row
      const lastSF = student.schoolFees[student.schoolFees.length - 1];
      acc.sf.fee         += parseFloat(lastSF.fee_amount || 0);
      acc.sf.outstanding += parseFloat(lastSF.outstanding || 0);
      student.schoolFees.forEach(sf => {
        acc.sf.paid += parseFloat(sf.exact_paid || 0);
      });
    } else {
      // Student has never paid — look up expected fee from feeAmounts config
      const expectedFee = parseFloat(feeAmounts[classKey] || 0);
      acc.sf.fee         += expectedFee;
      acc.sf.outstanding += expectedFee; // fully outstanding
      // paid stays 0
    }

    if (student.miscFees.length > 0) {
      // Derive totals from their actual misc fee records
      // Total fee = sum of each fee type's amount (use latest record per name)
      const latestByName = student.miscFees.reduce((map, mf) => {
        map[mf.name] = mf; // records are ordered ASC, so last write wins = latest
        return map;
      }, {});
      Object.values(latestByName).forEach(mf => {
        acc.misc.fee         += parseFloat(mf.amount || 0);
        acc.misc.outstanding += parseFloat(mf.outstanding || 0);
      });
      student.miscFees.forEach(mf => {
        acc.misc.paid += parseFloat(mf.exact_paid || 0);
      });
    } else {
      // Student has never paid misc fees — use the standard expected total
      const expectedMisc = baseMiscFeeTotal(student.class);
      acc.misc.fee         += expectedMisc;
      acc.misc.outstanding += expectedMisc;
      // paid stays 0
    }

    return acc;
  },
  {
    sf:   { fee: 0, paid: 0, outstanding: 0 },
    misc: { fee: 0, paid: 0, outstanding: 0 }
  }
);

const fmt = n => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Fee Records — Grade ${selectedClass}</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }


* { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
html, body { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
    body { font-family: Arial, sans-serif; font-size: 11px; color: #111;
           padding: 12mm; background: white; }
    .sf-print-report-header { text-align: center; border-bottom: 2px solid #0a192f;
           padding-bottom: 10px; margin-bottom: 16px; }
    .sf-print-report-title { font-size: 18px; font-weight: 700; letter-spacing: 1px;
           text-transform: uppercase; color: #0a192f; margin-bottom: 2px; }
    .sf-print-report-sub { font-size: 12px; color: #555; }
    .sf-print-cards-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8mm; }
    .sf-print-card { border: 1px solid #ccc; border-radius: 6px; overflow: hidden;
           page-break-inside: avoid; break-inside: avoid; }
    .sf-print-card-header { background: #0a192f; color: #ffffff; padding: 8px 12px;
           display: flex; justify-content: space-between; align-items: center;
           border-bottom: 2px solid #00f2fe; }
    .sf-print-card-name { font-size: 12px; font-weight: 800; color: #00f2fe;
           letter-spacing: 0.4px; }
    .sf-print-card-meta { font-size: 10px; font-weight: 600; color: #e0f7ff; }
    .sf-print-card-body { padding: 8px 12px; background: white; }
    .sf-print-section-label { font-size: 9px; font-weight: 700; text-transform: uppercase;
           letter-spacing: 1px; color: #1a6bc2; border-bottom: 1px solid #e0e0e0;
           padding-bottom: 3px; margin: 6px 0 4px; }
    .sf-print-history-entry { background: #f9f9f9; border-left: 3px solid #4facfe;
           padding: 3px 8px; margin-bottom: 3px; font-size: 10px; border-radius: 0 4px 4px 0; }
    .sf-print-history-date { font-weight: 600; color: #0a192f; }
    .sf-print-paid { color: #27ae60; font-weight: 600; }
    .sf-print-outstanding { color: #e74c3c; font-weight: 600; }
    .sf-print-outstanding-old { color: #e67e22; font-weight: 600; }
    .sf-print-footer { margin-top: 12mm; border-top: 1px solid #ccc; padding-top: 6px;
           font-size: 9px; color: #888; display: flex; justify-content: space-between; }

           .sf-print-totals { margin-top: 10mm; border: 2px solid #0a192f; border-radius: 6px; overflow: hidden; page-break-inside: avoid; break-inside: avoid; }
    .sf-print-totals-title { background: #0a192f; color: #00f2fe; font-size: 12px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; padding: 8px 14px; }
    .sf-print-totals-table { width: 100%; border-collapse: collapse; background: white; }
    .sf-print-totals-table thead tr { background: #f0f4f8; }
    .sf-print-totals-table th { padding: 6px 14px; text-align: left; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; color: #0a192f; border-bottom: 1px solid #ccc; }
    .sf-print-totals-table td { padding: 7px 14px; font-size: 11px; border-bottom: 1px solid #eee; }
    .sf-print-totals-table tbody tr:last-child td { border-bottom: none; }
    .sf-print-totals-label { font-weight: 700; color: #1a6bc2; }
    @page { size: A4; margin: 0; }
  </style>
</head>
<body>
  <div class="sf-print-report-header">
    <div class="sf-print-report-title">Eastern Pacific Academy — Fee Records</div>
    <div class="sf-print-report-sub">Grade ${selectedClass} &nbsp;|&nbsp; Printed: ${printDate} &nbsp;|&nbsp; Total Students: ${records.length}</div>
  </div>
  <div class="sf-print-cards-grid">${cards}</div>

  <!-- ── Class Totals Summary ── -->
  <div class="sf-print-totals">
    <div class="sf-print-totals-title">Grade ${selectedClass} — Summary Totals</div>
    <table class="sf-print-totals-table">
      <thead>
        <tr>
          <th></th>
          <th>Total Fee</th>
          <th>Total Paid</th>
          <th>Total Outstanding</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="sf-print-totals-label">School Fees</td>
          <td>K${fmt(classTotals.sf.fee)}</td>
          <td class="sf-print-paid">K${fmt(classTotals.sf.paid)}</td>
          <td class="sf-print-outstanding">K${fmt(classTotals.sf.outstanding)}</td>
        </tr>
        <tr>
          <td class="sf-print-totals-label">Miscellaneous Fees</td>
          <td>K${fmt(classTotals.misc.fee)}</td>
          <td class="sf-print-paid">K${fmt(classTotals.misc.paid)}</td>
          <td class="sf-print-outstanding">K${fmt(classTotals.misc.outstanding)}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="sf-print-footer">
    <span>EPA School Management System</span>
    <span>Confidential — Admin Use Only</span>
  </div>
</body>
</html>`;
};
// ─────────────────────────────────────────────────────────────────────────────

const SortableHeader = ({ label, sortField, currentSort, onClick }) => {
  const isActive = currentSort.field === sortField;
  const icon = isActive
    ? currentSort.direction === 'ASC'
    ? '▲' // Up arrow for ASC
      : '▼' // Down arrow for DESC
    : '⇅'; // Both arrows for inactive
  return (
    <div 
      style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
      onClick={() => onClick(sortField)}
    >
      <span>{label}</span>
      <span style={{ marginLeft: '5px', fontSize: '0.8em' }}>
        {icon}
      </span>
    </div>
  );
};

  return (
    <>
              <div className="sf-page">
                {/* ── Header ── */}
                   <div className="row my-4">
                <div className="col-12">
                  <h3>
                    School Fees
                    <img className="animated-icons" src={FeeIcon} alt="School fee icon" />
                  </h3>
                </div>
              </div>
                                
                <div className="sf-main-container">

                  {/* Staff alert */}
                  {userRole === 'staff' && (
                    <div className="sf-staff-alert">
                      <span className="sf-alert-icon">ℹ</span>
                      You have view-only access as a staff member.
                    </div>
                  )}

                  {/* Fee amounts loading indicator */}
                  {isFeeAmountsLoading && (
                    <div className="sf-staff-alert">
                      <span className="sf-alert-icon">ℹ</span>
                      Loading fee amounts...
                    </div>
                  )}

                  {/* ══════════════════════════════════════════
                      SECTION 1 — Submitted Fee Records
                  ══════════════════════════════════════════ */}
                  <section className="sf-table-section">
                    <h4 className="sf-section-title">Submitted Fee Records</h4>

                    {/* Filter Controls */}
                    <div className="sf-form-card">
                      <div className="sf-filter-input-wrap">
                        <input
                          type="text"
                          className="sf-filter-input"
                          placeholder="Filter by student name"
                          onChange={handleNameFilterChange}
                          value={filterName}
                        />
                      </div>
                      <div className="sf-filter-input-wrap">
                        <select
                          className="sf-filter-input"
                          onChange={handleClassFilterChange}
                          value={filterClass}
                        >
                          <option value="">All Classes</option>
                          {['6', '7', '8', '9', '10', '11', '12'].map(cls => (
                            <option key={cls} value={cls}>{cls}</option>
                          ))}
                        </select>
                      </div>

                        <div className="sf-filter-input-wrap">
                      <select
                               className="sf-filter-input"
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                      >
                        {[selectedYear - 2, selectedYear - 1, selectedYear, selectedYear + 1].map(y => (
                          <option key={y} value={y}>{y}</option>
                        ))}
                      </select>
                       </div>

                      {/* Sort dropdown */}
                      <div className="sf-sort-dropdown">
                        <button
                          className="sf-sort-toggle"
                          type="button"
                          id="sortDropdown"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Sort By ▾
                        </button>
                        <div className="sf-sort-menu" aria-labelledby="sortDropdown">
                          <div className="sf-sort-header">Student Name</div>
                          <button className="sf-sort-item" onClick={() => handleSubmittedRecordsSort('s.studentName')}>A → Z</button>
                          <button className="sf-sort-item" onClick={() => handleSubmittedRecordsSort('s.studentName', 'DESC')}>Z → A</button>
                          <div className="sf-sort-divider" />
                          <div className="sf-sort-header">Class</div>
                          <button className="sf-sort-item" onClick={() => handleSubmittedRecordsSort('s.class')}>6 → 12</button>
                          <button className="sf-sort-item" onClick={() => handleSubmittedRecordsSort('s.class', 'DESC')}>12 → 6</button>
                          <div className="sf-sort-divider" />
                          <div className="sf-sort-header">Amount Paid</div>
                          <button className="sf-sort-item" onClick={() => handleSubmittedRecordsSort('sf.amount_paid')}>Low → High</button>
                          <button className="sf-sort-item" onClick={() => handleSubmittedRecordsSort('sf.amount_paid', 'DESC')}>High → Low</button>
                          <div className="sf-sort-divider" />
                          <div className="sf-sort-header">Payment Date</div>
                          <button className="sf-sort-item" onClick={() => handleSubmittedRecordsSort('sf.payment_date')}>Oldest → Newest</button>
                          <button className="sf-sort-item" onClick={() => handleSubmittedRecordsSort('sf.payment_date', 'DESC')}>Newest → Oldest</button>
                        </div>
                     </div>
                    </div>

                    <div className="sf-year-indicator">
                      Showing {selectedYear} Records
                    </div>

                  {/* Submitted Records — Card/Accordion Layout */}
                  <div className="sf-records-list">
                    {isLoadingSubmitted ? (
                      <div className="sf-loading-state">
                        <div className="sf-loader-wrap">
                          <div className="sf-loader-ring" />
                          <span className="sf-loader-text">Loading Submitted Fees</span>
                        </div>
                      </div>
                    ) : submittedFees.length === 0 ? (
                      <div className="sf-empty-state">
                        {filterName || filterClass ? 'No matching records found' : 'No submitted fees found'}
                      </div>
                    ) : (
                      <>
                        {/* Column headers */}
                        <div className="sf-record-header-row">
                          <span className="sf-rh-name">
                            <SortableHeader label="Student" sortField="s.studentName" currentSort={submittedRecordsSort} onClick={handleSubmittedRecordsSort} />
                          </span>
                          <span className="sf-rh-status">Status</span>
                          <span className="sf-rh-class">
                            <SortableHeader label="Class" sortField="s.class" currentSort={submittedRecordsSort} onClick={handleSubmittedRecordsSort} />
                          </span>
                          <span className="sf-rh-sf">School Fee (K)</span>
                          <span className="sf-rh-misc">Misc Fees (K)</span>
                          <span className="sf-rh-expand" />
                        </div>

                        {submittedFees.map((record) => {
                          const classNum = parseInt(record.class.replace(/\D/g, ''));
                          const baseMiscFees = [
                            { id: 1, name: 'SRC Fee', amount: 20 },
                            { id: 2, name: 'ID Fee', amount: 20 },
                            { id: 5, name: 'Uniform', amount: 100 },
                            { id: 6, name: 'Computing fee', amount: 240 }
                          ];
                          const additionalFees = (classNum === 10 || classNum === 12) ? [
                            { id: 3, name: 'Gown Fee', amount: 50 },
                            { id: 4, name: 'Certificate processing fee', amount: 200 }
                          ] : [];
                          const allMiscFees = [...baseMiscFees, ...additionalFees];
                           // Use miscLatest for summary badges (paid/outstanding per fee type)
                          const mergedMiscFees = allMiscFees.map(fee => {
                            const latestEntry = (record.miscLatest || record.miscFees || []).find(f => f.name === fee.name);
                            return latestEntry ? latestEntry : { ...fee, paid: 0, outstanding: fee.amount };
                          });


                          const totalMiscPaid = mergedMiscFees.reduce((sum, f) => sum + parseFloat(f.paid || 0), 0);
                          const totalMiscOutstanding = mergedMiscFees.reduce((sum, f) => sum + parseFloat(f.outstanding || 0), 0);
                          const schoolFeeAmount = getSchoolFeeByClass(record.class);
                          const isExpanded = !!expandedRecords[record.student_id];

                            // Use full miscFees history for timeline, with exact_paid diff calculated
                          const miscByName = (record.miscFees || []).reduce((acc, mf, idx, arr) => {
                            if (!acc[mf.name]) acc[mf.name] = [];
                            const prev = arr.slice(0, idx).filter(r => r.name === mf.name && r.student_id === mf.student_id).pop();
                            acc[mf.name].push({ ...mf, exact_paid: parseFloat(mf.paid) - (prev ? parseFloat(prev.paid) : 0) });
                            return acc;
                          }, {});
                          
                         const schoolFeeHistory = record.schoolFeeHistory || (record.amount_paid > 0 ? [{
                            id: record.id,
                            payment_date: record.payment_date,
                            amount_paid: record.amount_paid,
                            outstanding: record.outstanding,
                            exact_paid: record.amount_paid
                          }] : []);

                          return (
                            <div
                              key={`${record.student_id}-${record.payment_date}`}
                              className={`sf-record-card ${
                                record.enrollmentStatus === 'Expelled' ? 'sf-record-expelled' :
                                record.enrollmentStatus === 'Passed Out' ? 'sf-record-passed' :
                                record.enrollmentStatus === 'Withdrawn' ? 'sf-record-withdrawn' : ''
                              }`}
                            >
                              {/* Summary row — always visible */}
                              <div className="sf-record-summary" onClick={() => toggleRecordExpand(record.student_id)}>
                                <span className="sf-rh-name">
                                  <div className="sf-name-container">
                                    <span
                                      className="sf-name-hoverable"
                                      onClick={e => e.stopPropagation()}
                                    >
                                      {record.studentName}
                                      <div className="sf-document-popup">
                                        {(userRole === 'admin') && (
                                          <>
                                            <button className="sf-doc-btn sf-doc-btn-primary"
                                              onClick={(e) => { e.stopPropagation(); handleDocumentActionRef.current('invoice', record); }}>
                                              <i className="bi bi-file-earmark-text" /> Create Invoice
                                            </button>
                                            <button className="sf-doc-btn sf-doc-btn-success"
                                              onClick={(e) => { e.stopPropagation(); handleDocumentActionRef.current('receipt', record); }}>
                                              <i className="bi bi-receipt" /> Create Receipt
                                            </button>
                                            <button className="sf-doc-btn sf-doc-btn-warning"
                                              onClick={(e) => { e.stopPropagation(); handleDocumentActionRef.current('overdue-reminder', record); }}>
                                              <i className="bi bi-exclamation-triangle" /> Overdue Reminder
                                            </button>
                                            <button className="sf-doc-btn sf-doc-btn-danger"
                                              onClick={(e) => { e.stopPropagation(); handleDocumentActionRef.current('overdue-statement', record); }}>
                                              <i className="bi bi-file-earmark-pdf" /> Overdue Statement
                                            </button>
                                          </>
                                        )}
                                      </div>
                                    </span>
                                  </div>
                                </span>
                                <span className="sf-rh-status">
                                  <span className={`sf-status-badge ${
                                    record.enrollmentStatus === 'Expelled' ? 'sf-badge-danger' :
                                    record.enrollmentStatus === 'Passed Out' ? 'sf-badge-info' :
                                    record.enrollmentStatus === 'Withdrawn' ? 'sf-badge-warning' : 'sf-badge-success'
                                  }`}>
                                    {record.enrollmentStatus}
                                  </span>
                                </span>
                                <span className="sf-rh-class">{record.class}</span>
                                <span className="sf-rh-sf">
                                  <span className="sf-summary-label">Fee:</span> K{formatNumber(schoolFeeAmount)}<br />
                                  <span className="sf-summary-paid">Paid: K{formatNumber(record.amount_paid)}</span><br />
                                  <span className={`sf-summary-outstanding ${record.outstanding <= 0 ? 'sf-paid-full' : ''}`}>
                                    Owing: K{formatNumber(record.outstanding <= 0 ? 0 : record.outstanding)}
                                  </span>
                                </span>
                                <span className="sf-rh-misc">
                                  <span className="sf-summary-paid">Paid: K{formatNumber(totalMiscPaid)}</span><br />
                                  <span className={`sf-summary-outstanding ${totalMiscOutstanding <= 0 ? 'sf-paid-full' : ''}`}>
                                    Owing: K{formatNumber(totalMiscOutstanding)}
                                  </span>
                                </span>
                                <span className="sf-rh-expand">
                                  <span className={`sf-expand-chevron ${isExpanded ? 'sf-expanded' : ''}`}>▼</span>
                                </span>
                              </div>

                           {record.previousYearOutstanding > 0 && (
  <div className="sf-prev-balance-row">
    <span className="sf-status-badge sf-badge-warning">
      {selectedYear - 1} Balance Owing: K{formatNumber(record.previousYearOutstanding)}
    </span>
  </div>
)}

                              {/* Expanded detail panel */}
                              {isExpanded && (
                                <div className="sf-record-detail">

                                  {/* ── School Fee History ── */}
                                  <div className="sf-detail-section">
                                    <div className="sf-detail-section-title">
                                      School Fee
                                      <span className="sf-detail-section-meta">
                                        Total: K{formatNumber(schoolFeeAmount)}
                                      </span>
                                    </div>
                                    {schoolFeeHistory.length === 0 ? (
                                      <div className="sf-detail-empty">No school fee payments recorded.</div>
                                    ) : (
                                      <div className="sf-payment-timeline">
                                        {schoolFeeHistory.map((entry, idx) => {
                                          const isLatest = idx === schoolFeeHistory.length - 1;
                                          return (
                                            <div key={idx} className={`sf-timeline-entry ${isLatest ? 'sf-timeline-latest' : ''}`}>
                                              <span className="sf-timeline-date">
                                                {entry.payment_date
                                                  ? new Date(entry.payment_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
                                                  : '—'}
                                              </span>
                                              <span className="sf-timeline-paid">K{formatNumber(entry.exact_paid ?? entry.amount_paid)}</span>
                                              <span className={`sf-timeline-owing ${
                                                    isLatest && entry.outstanding <= 0 ? 'sf-paid-full' :
                                                    isLatest ? 'sf-owing-current' : 'sf-owing-historical'
                                                  }`}>
                                                    <span className="sf-timeline-owing-label">
                                                      {isLatest ? 'Current Outstanding:' : 'Balance after:'}
                                                    </span>
                                                    {' '}K{formatNumber(entry.outstanding)}
                                                  </span>
                                              {isLatest && (
                                                <span className="sf-timeline-current-badge">Latest</span>
                                              )}
                                             {userRole === 'admin' && (
                                              <span className="sf-timeline-actions">
                                                <button className="sf-action-btn sf-action-edit"
                                                  onClick={() => handleEditSchoolFee({ id: entry.id, exact_paid: entry.exact_paid ?? entry.amount_paid, fee_amount: schoolFeeAmount, outstanding: entry.outstanding })}>
                                                  <PencilSquare />
                                                </button>
                                                <button className="sf-action-btn sf-action-delete"
                                                  onClick={() => showDeleteModal('school', entry.id, record.studentName)}>
                                                  <Trash />
                                                </button>
                                              </span>
                                            )}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    )}
                                  </div>

                                  {/* ── Misc Fee History — one section per fee type ── */}
                                  <div className="sf-detail-section">
                                    <div className="sf-detail-section-title">Miscellaneous Fees</div>
                                    <div className="sf-misc-fee-groups">
                                      {mergedMiscFees.map((fee) => {
                                        const history = miscByName[fee.name] || [];
                                        return (
                                          <div key={fee.name} className="sf-misc-fee-group">
                                            <div className="sf-misc-fee-group-header">
                                              <span className="sf-misc-fee-name">{fee.name}</span>
                                              <span className="sf-misc-fee-total">K{formatNumber(fee.amount)}</span>
                                              <span className={`sf-misc-fee-status ${fee.outstanding <= 0 ? 'sf-paid-full' : fee.paid > 0 ? 'sf-paid-partial' : 'sf-unpaid'}`}>
                                                {fee.outstanding <= 0 ? '✓ Paid' : fee.paid > 0 ? `K${formatNumber(fee.outstanding)} owing` : 'Unpaid'}
                                              </span>
                                            </div>
                                            {history.length === 0 ? (
                                              <div className="sf-detail-empty">No payments yet.</div>
                                            ) : (
                                              <div className="sf-payment-timeline">
                                                {history.map((entry, idx) => {
                                                  const isLatest = idx === history.length - 1;
                                                  return (
                                                    <div key={idx} className={`sf-timeline-entry ${isLatest ? 'sf-timeline-latest' : ''}`}>
                                                      <span className="sf-timeline-date">
                                                        {entry.payment_date
                                                          ? new Date(entry.payment_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
                                                          : '—'}
                                                      </span>
                                                      <span className="sf-timeline-paid">K{formatNumber(entry.exact_paid ?? entry.paid)}</span>
                                                     <span className={`sf-timeline-owing ${
                                                      isLatest && entry.outstanding <= 0 ? 'sf-paid-full' :
                                                      isLatest ? 'sf-owing-current' : 'sf-owing-historical'
                                                    }`}>
                                                      <span className="sf-timeline-owing-label">
                                                        {isLatest ? 'Current Outstanding:' : 'Balance after:'}
                                                      </span>
                                                      {' '}K{formatNumber(entry.outstanding)}
                                                    </span>
                                                    {isLatest && (
                                                      <span className="sf-timeline-current-badge">Latest</span>
                                                    )}
                                                      {userRole === 'admin' && (
                                                        <span className="sf-timeline-actions">
                                                          <button className="sf-action-btn sf-action-edit"
                                                          onClick={() => handleEditMiscFee({ id: entry.id, name: fee.name, amount: fee.amount, exact_paid: entry.exact_paid ?? entry.paid, outstanding: entry.outstanding })}>
                                                            <PencilSquare />
                                                          </button>
                                                          <button className="sf-action-btn sf-action-delete"
                                                            onClick={() => showDeleteModal('misc', entry.id, record.studentName)}>
                                                            <Trash />
                                                          </button>
                                                        </span>
                                                      )}
                                                    </div>
                                                  );
                                                })}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>

                                </div>
                              )}
                            </div>
                          );
                        })}

                        {/* Totals bar */}
                  <div className="sf-records-totals">
                    <div className="sf-totals-block">
                      <div className="sf-totals-block-title">School Fee Summary</div>
                      <div className="sf-totals-row-item">
                        <span className="sf-totals-item-label">Total Fee</span>
                        <span className="sf-totals-item-value">K{formatNumber(totals.schoolFee.total_fee)}</span>
                      </div>
                      <div className="sf-totals-row-item">
                        <span className="sf-totals-item-label">Total Paid</span>
                        <span className="sf-totals-item-value sf-totals-paid">K{formatNumber(totals.schoolFee.total_paid)}</span>
                      </div>
                      <div className="sf-totals-row-item">
                        <span className="sf-totals-item-label">Total Outstanding</span>
                        <span className="sf-totals-item-value sf-totals-outstanding">K{formatNumber(totals.schoolFee.total_outstanding)}</span>
                      </div>
                    </div>
                    <div className="sf-totals-block">
                      <div className="sf-totals-block-title">Miscellaneous Fee Summary</div>
                      <div className="sf-totals-row-item">
                        <span className="sf-totals-item-label">Total Fee</span>
                        <span className="sf-totals-item-value">K{formatNumber(totals.miscFee.total_fee)}</span>
                      </div>
                      <div className="sf-totals-row-item">
                        <span className="sf-totals-item-label">Total Paid</span>
                        <span className="sf-totals-item-value sf-totals-paid">K{formatNumber(totals.miscFee.total_paid)}</span>
                      </div>
                      <div className="sf-totals-row-item">
                        <span className="sf-totals-item-label">Total Outstanding</span>
                        <span className="sf-totals-item-value sf-totals-outstanding">K{formatNumber(totals.miscFee.total_outstanding)}</span>
                      </div>
                    </div>
                  </div>
                      </>
                    )}
                  </div>

                    {/* Submitted Fees — Pagination */}
                    <div className="sf-pagination-wrapper">
                      <div className="sf-pagination-info">
                        {isPageLoading
                          ? 'Loading...'
                          : `Showing ${submittedFees.length} of ${pagination.submittedFees.totalItems} records`}
                        {(filterName || filterClass) && ' (filtered)'}
                      </div>
                      <nav>
                        <ul className="sf-pagination">
                          {/* Previous */}
                          <li className={`sf-page-item${pagination.submittedFees.currentPage === 1 ? ' sf-disabled' : ''}`}>
                            <button
                              className="sf-page-link"
                              onClick={() => fetchSubmittedFees(pagination.submittedFees.currentPage - 1)}
                              disabled={pagination.submittedFees.currentPage === 1 || isPageLoading}
                            >
                              {isPageLoading && pagination.submittedFees.currentPage === 1
                                ? <span className="sf-spinner" />
                                : '← Prev'}
                            </button>
                          </li>

                          {/* Page numbers — responsive windowed */}
                          {(() => {
                            const total = pagination.submittedFees.totalPages;
                            const current = pagination.submittedFees.currentPage;
                            const delta = 2;
                            const pages = [];

                            for (let i = 1; i <= total; i++) {
                              if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
                                pages.push(i);
                              }
                            }

                            const result = [];
                            let prev = null;
                            for (const page of pages) {
                              if (prev !== null && page - prev > 1) {
                                result.push(<li key={`sf-ellipsis-${prev}`} className="sf-page-item sf-page-ellipsis"><span className="sf-page-link sf-ellipsis-link">…</span></li>);
                              }
                              result.push(
                                <li key={page} className={`sf-page-item${current === page ? ' sf-active' : ''}`}>
                                  <button className="sf-page-link" onClick={() => fetchSubmittedFees(page)}>
                                    {page}
                                  </button>
                                </li>
                              );
                              prev = page;
                            }
                            return result;
                          })()}

                          {/* Next */}
                          <li className={`sf-page-item${pagination.submittedFees.currentPage === pagination.submittedFees.totalPages ? ' sf-disabled' : ''}`}>
                            <button
                              className="sf-page-link"
                              onClick={() => fetchSubmittedFees(pagination.submittedFees.currentPage + 1)}
                              disabled={pagination.submittedFees.currentPage === pagination.submittedFees.totalPages || isPageLoading}
                            >
                              Next →
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </section>

                  {/* ExtraCard */}
                  <ExtraCard />

                  {/* ── Action bar: Export / Manage Fees / Statistics toggle ── */}
                  <div className="sf-action-bar">
                    {userRole === 'admin' && (
                    <button
                      className="sf-btn sf-btn-print"
                      onClick={() => handlePrintClick('full')}
                      title="Print fee records by class"
                    >
                      <i className="bi bi-printer-fill sf-btn-icon" />
                      Print by Class
                    </button>
                    
                  )}
                  {(userRole === 'admin') && (
                  <button
                className="sf-btn sf-btn-print"
                onClick={() => handlePrintClick('schoolFeeOnly')}
                title="Print school fee records only (no misc fees)"
              >
                <i className="bi bi-file-earmark-text sf-btn-icon" />
                Print School Fee Only
              </button>
                  )}
                    {(userRole === 'admin') && (
                      <FeeExport
                        filteredSubmittedFees={filteredSubmittedFees}
                        formatNumber={formatNumber}
                        getSchoolFeeByClass={getSchoolFeeByClass}
                        showToastMessage={showToastMessage}
                      />
                    )}
                    {(userRole === 'admin') && (
                      <button className="sf-btn sf-btn-info" onClick={() => setShowFeeAmountsModal(true)}>
                        <Gear className="sf-btn-icon" />
                        Manage Fee Amounts
                      </button>
                    )}
                    <button
                    className="sf-btn sf-btn-warning"
                    onClick={() => setShowStatistics(!showStatistics)}
                  >
                    <BarChartFill />
                    {showStatistics ? 'Hide Statistics' : 'Show Statistics'}
                  </button>
                  </div>

                  {/* ══════════════════════════════════════════
                      Statistics Section
                  ══════════════════════════════════════════ */}
                <div className={`sf-statistics-section${showStatistics ? ' sf-stats-show' : ' sf-stats-hide'}`}>
                    <h4 className="sf-section-title">Fee Statistics</h4>

                    {(() => {
                      const sfPaid        = parseFloat(totals.schoolFee.total_paid) || 0;
                      const sfOutstanding = parseFloat(totals.schoolFee.total_outstanding) || 0;
                      const sfTotal       = parseFloat(totals.schoolFee.total_fee) || 0;
                      const mfPaid        = parseFloat(totals.miscFee.total_paid) || 0;
                      const mfOutstanding = parseFloat(totals.miscFee.total_outstanding) || 0;
                      const mfTotal       = parseFloat(totals.miscFee.total_fee) || 0;

                      const sfPct = sfTotal > 0 ? Math.round((sfPaid / sfTotal) * 100) : 0;
                      const mfPct = mfTotal > 0 ? Math.round((mfPaid / mfTotal) * 100) : 0;
                      const overallPaid  = sfPaid + mfPaid;
                      const overallTotal = sfTotal + mfTotal;
                      const overallPct   = overallTotal > 0 ? Math.round((overallPaid / overallTotal) * 100) : 0;

                      const PAID_COLOR        = '#2ecc71';
                      const OUTSTANDING_COLOR = '#ff6b6b';
                      const EMPTY_COLOR       = 'rgba(79,172,254,0.1)';

                      const sfData = sfTotal > 0
                        ? [{ name: 'Paid', value: sfPaid }, { name: 'Outstanding', value: sfOutstanding }]
                        : [{ name: 'No data', value: 1 }];
                      const mfData = mfTotal > 0
                        ? [{ name: 'Paid', value: mfPaid }, { name: 'Outstanding', value: mfOutstanding }]
                        : [{ name: 'No data', value: 1 }];

                      const DonutLabel = ({ cx, cy, pct, label }) => (
                        <>
                          <text x={cx} y={cy - 10} textAnchor="middle" fill="#00f2fe"
                            style={{ fontFamily: 'Orbitron, sans-serif', fontSize: '1.4rem', fontWeight: 700 }}>
                            {pct}%
                          </text>
                          <text x={cx} y={cy + 14} textAnchor="middle" fill="rgba(255,255,255,0.5)"
                            style={{ fontFamily: 'Rajdhani, sans-serif', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
                            {label}
                          </text>
                        </>
                      );

                      const ChartTooltip = ({ active, payload }) => {
                        if (!active || !payload?.length) return null;
                        return (
                          <div style={{ background: '#0a192f', border: '1px solid rgba(79,172,254,0.3)', borderRadius: 8, padding: '8px 12px' }}>
                            <p style={{ color: payload[0].name === 'Paid' ? PAID_COLOR : OUTSTANDING_COLOR, fontFamily: 'Rajdhani', fontWeight: 700, margin: 0 }}>
                              {payload[0].name}: K{formatNumber(payload[0].value)}
                            </p>
                          </div>
                        );
                      };

                      return (
                        <div className="sf-charts-container">

                          {/* ── Donut charts row ── */}
                          <div className="sf-donuts-row">

                            {/* School Fee donut */}
                            <div className="sf-donut-card">
                              <div className="sf-donut-title">School Fee Collection</div>
                              <ResponsiveContainer width="100%" height={200}>
                                <PieChart>
                                  <Pie data={sfData} cx="50%" cy="50%" innerRadius={60} outerRadius={85}
                                    paddingAngle={sfTotal > 0 ? 3 : 0} dataKey="value" strokeWidth={0}>
                                    {sfTotal > 0
                                      ? [PAID_COLOR, OUTSTANDING_COLOR].map((color, i) => <Cell key={i} fill={color} />)
                                      : <Cell fill={EMPTY_COLOR} />}
                                  </Pie>
                                  <Tooltip content={<ChartTooltip />} />
                                  <DonutLabel cx="50%" cy="50%" pct={sfPct} label="collected" />
                                </PieChart>
                              </ResponsiveContainer>
                              <div className="sf-donut-legend">
                                <span className="sf-legend-dot" style={{ background: PAID_COLOR }} />
                                <span className="sf-legend-label">Paid: <strong>K{formatNumber(sfPaid)}</strong></span>
                                <span className="sf-legend-dot" style={{ background: OUTSTANDING_COLOR }} />
                                <span className="sf-legend-label">Owing: <strong>K{formatNumber(sfOutstanding)}</strong></span>
                              </div>
                            </div>

                            {/* Misc Fee donut */}
                            <div className="sf-donut-card">
                              <div className="sf-donut-title">Misc Fee Collection</div>
                              <ResponsiveContainer width="100%" height={200}>
                                <PieChart>
                                  <Pie data={mfData} cx="50%" cy="50%" innerRadius={60} outerRadius={85}
                                    paddingAngle={mfTotal > 0 ? 3 : 0} dataKey="value" strokeWidth={0}>
                                    {mfTotal > 0
                                      ? [PAID_COLOR, OUTSTANDING_COLOR].map((color, i) => <Cell key={i} fill={color} />)
                                      : <Cell fill={EMPTY_COLOR} />}
                                  </Pie>
                                  <Tooltip content={<ChartTooltip />} />
                                  <DonutLabel cx="50%" cy="50%" pct={mfPct} label="collected" />
                                </PieChart>
                              </ResponsiveContainer>
                              <div className="sf-donut-legend">
                                <span className="sf-legend-dot" style={{ background: PAID_COLOR }} />
                                <span className="sf-legend-label">Paid: <strong>K{formatNumber(mfPaid)}</strong></span>
                                <span className="sf-legend-dot" style={{ background: OUTSTANDING_COLOR }} />
                                <span className="sf-legend-label">Owing: <strong>K{formatNumber(mfOutstanding)}</strong></span>
                              </div>
                            </div>

                          </div>

                          {/* ── Overall collection progress bar ── */}
                          <div className="sf-progress-card">
                            <div className="sf-progress-header">
                              <span className="sf-progress-title">Overall Fee Collection Progress</span>
                              <span className="sf-progress-pct">{overallPct}%</span>
                            </div>
                            <div className="sf-progress-track">
                              <div className="sf-progress-fill" style={{ width: `${overallPct}%` }} />
                            </div>
                            <div className="sf-progress-footer">
                              <span>K{formatNumber(overallPaid)} collected</span>
                              <span>K{formatNumber(overallTotal)} total</span>
                            </div>
                          </div>

                        </div>
                      );
                    })()}
                  </div>

                  {/* ══════════════════════════════════════════
                      SECTION 2 — New Fee Entries
                  ══════════════════════════════════════════ */}
                  <section className="sf-table-section">
                    <h4 className="sf-section-title">New Fee Entries</h4>

                    {/* Filter Controls for New Entries */}
                    <div className="sf-form-card">
                      <div className="sf-filter-input-wrap">
                        <input
                          type="text"
                          className="sf-filter-input"
                          placeholder="Filter by student name"
                          onChange={handleNewEntriesNameFilter}
                          value={newEntriesFilterName}
                        />
                      </div>
                      <div className="sf-filter-input-wrap">
                        <select
                          className="sf-filter-input"
                          onChange={handleNewEntriesClassFilter}
                          value={newEntriesFilterClass}
                        >
                          <option value="">All Classes</option>
                          {['6', '7', '8', '9', '10', '11', '12'].map(cls => (
                            <option key={cls} value={cls}>{cls}</option>
                          ))}
                        </select>
                      </div>

                      {/* Sort dropdown */}
                      <div className="sf-sort-dropdown">
                        <button
                          className="sf-sort-toggle"
                          type="button"
                          id="newEntriesSortDropdown"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Sort By ▾
                        </button>
                        <div className="sf-sort-menu" aria-labelledby="newEntriesSortDropdown">
                          <div className="sf-sort-header">Student Name</div>
                          <button className="sf-sort-item" onClick={() => requestSort('studentName', true)}>A → Z</button>
                          <button className="sf-sort-item" onClick={() => requestSort('studentName', true, true)}>Z → A</button>
                          <div className="sf-sort-divider" />
                          <div className="sf-sort-header">Class</div>
                          <button className="sf-sort-item" onClick={() => requestSort('class', true)}>6 → 12</button>
                          <button className="sf-sort-item" onClick={() => requestSort('class', true, true)}>12 → 6</button>
                        </div>
                      </div>
                    </div>

{/* New Entries Table */}
<div className="sf-table-container">
  <div className="sf-table-wrapper">
    <table className="sf-table">
      <thead className="sf-table-header">
        <tr>
          <th rowSpan="2">Student</th>
          <th rowSpan="2">Status</th>
          <th rowSpan="2">Class</th>
          <th rowSpan="2">School Fee (K)</th>
         <th colSpan="3" className="sf-th-center">School Fee Payment</th>
<th colSpan="3" className="sf-th-center">Miscellaneous Fee</th>
</tr>
<tr className="sf-table-subheader">
  <th>Amount (K)</th>
  <th>Date</th>
  <th>Academic Year</th>
  <th>Name</th>
  <th>Amount (K)</th>
  <th>Payment Details</th>
</tr>
      </thead>

      {isLoading ? (
        <tbody>
          <tr>
            <td colSpan="9" className="sf-loading-state">
            <div className="sf-loader-wrap">
              <div className="sf-loader-ring" />
              <span className="sf-loader-text">Loading Fee Entries</span>
            </div>
          </td>
          </tr>
        </tbody>
      ) : filteredFeeData.length === 0 ? (
        <tbody>
          <tr>
            <td colSpan="9" className="sf-empty-state">
              {newEntriesFilterName || newEntriesFilterClass
                ? 'No matching records found'
                : 'No students found'}
            </td>
          </tr>
        </tbody>
      ) : (
        filteredFeeData.map((student) => (
          <tbody
            className="sf-student-group"
            key={student.studentId}
          >
            {student.miscFees.map((fee, feeIndex) => (
              <tr
                key={`${student.studentId}-${fee.id}`}
                className={
                  student.enrollmentStatus === 'Expelled' ? 'sf-row-expelled' :
                  student.enrollmentStatus === 'Passed Out' ? 'sf-row-passed' :
                  student.enrollmentStatus === 'Withdrawn' ? 'sf-row-withdrawn' : ''
                }
              >
                {feeIndex === 0 && (
                  <>
                    <td rowSpan={student.miscFees.length}>{student.studentName}</td>
                    <td rowSpan={student.miscFees.length}>
                      <span className={`sf-status-badge ${
                        student.enrollmentStatus === 'Expelled' ? 'sf-badge-danger' :
                        student.enrollmentStatus === 'Passed Out' ? 'sf-badge-info' :
                        student.enrollmentStatus === 'Withdrawn' ? 'sf-badge-warning' : 'sf-badge-success'
                      }`}>
                        {student.enrollmentStatus}
                      </span>
                    </td>
                    <td rowSpan={student.miscFees.length}>{student.class}</td>
                    <td rowSpan={student.miscFees.length}>{student.schoolFee}</td>
                    <td rowSpan={student.miscFees.length}>
                      <input
                        type="number"
                        className="sf-entry-input"
                        value={student.schoolFeePaid === '' ? '' : student.schoolFeePaid}
                        onChange={(e) => handleSchoolFeePaidChange(student.studentId, e.target.value)}
                        min="0"
                        placeholder="Enter amount"
                        disabled={['Expelled', 'Passed Out', 'Withdrawn'].includes(student.enrollmentStatus) || userRole !== 'admin'}
                      />
                    </td>
                   <td rowSpan={student.miscFees.length}>
  <input
    type="date"
    className="sf-entry-input"
    value={student.schoolFeePaymentDate}
    onChange={(e) => handleSchoolFeeDateChange(student.studentId, e.target.value)}
    disabled={['Expelled', 'Passed Out', 'Withdrawn'].includes(student.enrollmentStatus) || userRole !== 'admin'}
  />
</td>
<td rowSpan={student.miscFees.length}>
  <select
    className="sf-entry-input"
    value={student.academicYear}
    onChange={(e) => handleAcademicYearChange(student.studentId, e.target.value)}
    disabled={['Expelled', 'Passed Out', 'Withdrawn'].includes(student.enrollmentStatus) || userRole !== 'admin'}
  >
    {[selectedYear - 1, selectedYear, selectedYear + 1, selectedYear + 2].map(y => (
      <option key={y} value={y}>{y}</option>
    ))}
  </select>
</td>
                  </>
                )}
                <td>{fee.name}</td>
                <td>{fee.amount}</td>
                <td>
                  <div className="sf-misc-payment-cell">
                    <input
                      type="number"
                      className="sf-entry-input"
                      value={fee.paid === '' ? '' : fee.paid}
                      onChange={(e) => handleMiscFeePaidChange(student.studentId, fee.id, e.target.value)}
                      min="0"
                      placeholder="Amount"
                      disabled={['Expelled', 'Passed Out', 'Withdrawn'].includes(student.enrollmentStatus) || userRole !== 'admin'}
                    />
                    <input
                      type="date"
                      className="sf-entry-input"
                      value={fee.paymentDate}
                      onChange={(e) => handleMiscFeeDateChange(student.studentId, fee.id, e.target.value)}
                      disabled={['Expelled', 'Passed Out', 'Withdrawn'].includes(student.enrollmentStatus) || userRole !== 'admin'}
                    />
                  </div>
                </td>
              </tr>
            ))}

            {/* Per-student submit row */}
            {(userRole === 'admin') && (
              <tr>
                <td colSpan="9" className="sf-submit-row-cell">
                  <button
                    className="sf-btn sf-btn-success"
                    onClick={() => handleSubmitStudentData(student)}
                  >
                    Submit for {student.studentName}
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        ))
      )}

    </table>
  </div>
</div>
                    {/* New Entries — Pagination */}
                    <div className="sf-pagination-wrapper">
                      <div className="sf-pagination-info">
                        {isPageLoading
                          ? 'Loading...'
                          : (newEntriesFilterName || newEntriesFilterClass)
                            ? `${students.length} matching records`
                            : `${Math.min(
                                pagination.newEntries.currentPage * pagination.newEntries.itemsPerPage,
                                pagination.newEntries.totalItems
                              )} of ${pagination.newEntries.totalItems} records`}
                      </div>
                      <nav>
                        <ul className="sf-pagination">
                          {/* Previous */}
                          <li className={`sf-page-item${pagination.newEntries.currentPage === 1 ? ' sf-disabled' : ''}`}>
                            <button
                              className="sf-page-link"
                              onClick={() => handleNewEntriesPageChange(pagination.newEntries.currentPage - 1)}
                              disabled={pagination.newEntries.currentPage === 1 || isPageLoading}
                            >
                              {isPageLoading && pagination.newEntries.currentPage === 1
                                ? <span className="sf-spinner" />
                                : '← Prev'}
                            </button>
                          </li>

                          {/* Page numbers — responsive windowed */}
                          {(() => {
                            const total = pagination.newEntries.totalPages;
                            const current = pagination.newEntries.currentPage;
                            const delta = 2;
                            const pages = [];

                            for (let i = 1; i <= total; i++) {
                              if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
                                pages.push(i);
                              }
                            }

                            const result = [];
                            let prev = null;
                            for (const page of pages) {
                              if (prev !== null && page - prev > 1) {
                                result.push(<li key={`ne-ellipsis-${prev}`} className="sf-page-item sf-page-ellipsis"><span className="sf-page-link sf-ellipsis-link">…</span></li>);
                              }
                              result.push(
                                <li key={page} className={`sf-page-item${current === page ? ' sf-active' : ''}`}>
                                  <button className="sf-page-link" onClick={() => handleNewEntriesPageChange(page)}>
                                    {page}
                                  </button>
                                </li>
                              );
                              prev = page;
                            }
                            return result;
                          })()}

                          {/* Next */}
                          <li className={`sf-page-item${pagination.newEntries.currentPage === pagination.newEntries.totalPages ? ' sf-disabled' : ''}`}>
                            <button
                              className="sf-page-link"
                              onClick={() => handleNewEntriesPageChange(pagination.newEntries.currentPage + 1)}
                              disabled={pagination.newEntries.currentPage === pagination.newEntries.totalPages || isPageLoading}
                            >
                              Next →
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>

                    {/* Submit All */}
                    {(userRole === 'admin') && (
                      <div className="sf-submit-all-wrap">
                        <button className="sf-btn sf-btn-primary sf-btn-submit-all" onClick={handleSubmitAll}>
                          Submit All Changes
                        </button>
                      </div>
                    )}
                  </section>

                </div>{/* /sf-main-container */}
              </div>{/* /sf-page */}
           

      {/* ══════════════════════════════════════════
          Edit School Fee Modal
      ══════════════════════════════════════════ */}
      <Modal show={!!editingSchoolFee} onHide={() => setEditingSchoolFee(null)}>
  <Modal.Header closeButton className="sf-modal-header">
    <Modal.Title className="sf-modal-title">Edit School Fee Payment</Modal.Title>
  </Modal.Header>
  <Modal.Body className="sf-modal-body">
    <div className="sf-modal-form-group">
      <label className="sf-modal-label">Amount Paid on This Date</label>
      <input
        type="number"
        className="sf-modal-input"
        value={editingSchoolFee?.exact_paid ?? ''}
        onChange={(e) => {
          const value = e.target.value;
          if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
            setEditingSchoolFee({ ...editingSchoolFee, exact_paid: value });
          }
        }}
        min="0.01"
        step="0.01"
        max={editingSchoolFee?.fee_amount}
        onKeyDown={(e) => { if (['e', 'E', '+', '-'].includes(e.key)) e.preventDefault(); }}
      />
      {safeParseFloat(editingSchoolFee?.exact_paid) > editingSchoolFee?.fee_amount && (
        <small className="sf-modal-error">
          Amount cannot exceed the total fee (K{editingSchoolFee?.fee_amount})
        </small>
      )}
    </div>
  </Modal.Body>
  <Modal.Footer className="sf-modal-footer">
    <button className="sf-btn sf-btn-secondary" onClick={() => setEditingSchoolFee(null)}>Cancel</button>
    <button
      className="sf-btn sf-btn-primary"
      onClick={handleUpdateSchoolFee}
      disabled={
        !editingSchoolFee?.exact_paid ||
        safeParseFloat(editingSchoolFee.exact_paid) === null ||
        safeParseFloat(editingSchoolFee.exact_paid) <= 0 ||
        safeParseFloat(editingSchoolFee.exact_paid) > editingSchoolFee.fee_amount
      }
    >
      Save Changes
    </button>
  </Modal.Footer>
</Modal>
      {/* ══════════════════════════════════════════
          Edit Misc Fee Modal
      ══════════════════════════════════════════ */}
     <Modal show={!!editingMiscFee} onHide={() => setEditingMiscFee(null)}>
  <Modal.Header closeButton className="sf-modal-header">
    <Modal.Title className="sf-modal-title">Edit Miscellaneous Fee Payment</Modal.Title>
  </Modal.Header>
  <Modal.Body className="sf-modal-body">
    <div className="sf-modal-form-group">
      <label className="sf-modal-label">Fee Name</label>
      <input type="text" className="sf-modal-input" value={editingMiscFee?.name || ''} readOnly />
    </div>
    <div className="sf-modal-form-group">
      <label className="sf-modal-label">Amount Paid on This Date</label>
      <input
        type="number"
        className="sf-modal-input"
        value={editingMiscFee?.exact_paid ?? ''}
        onChange={(e) => {
          const value = e.target.value;
          if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
            setEditingMiscFee({ ...editingMiscFee, exact_paid: value });
          }
        }}
        min="0.01"
        step="0.01"
        max={editingMiscFee?.amount}
        onKeyDown={(e) => { if (['e', 'E', '+', '-'].includes(e.key)) e.preventDefault(); }}
      />
      {safeParseFloat(editingMiscFee?.exact_paid) > editingMiscFee?.amount && (
        <small className="sf-modal-error">
          Amount cannot exceed the total fee (K{editingMiscFee?.amount})
        </small>
      )}
    </div>
  </Modal.Body>
  <Modal.Footer className="sf-modal-footer">
    <button className="sf-btn sf-btn-secondary" onClick={() => setEditingMiscFee(null)}>Cancel</button>
    <button
      className="sf-btn sf-btn-primary"
      onClick={handleUpdateMiscFee}
      disabled={
        !editingMiscFee?.exact_paid ||
        safeParseFloat(editingMiscFee.exact_paid) === null ||
        safeParseFloat(editingMiscFee.exact_paid) <= 0 ||
        safeParseFloat(editingMiscFee.exact_paid) > editingMiscFee.amount
      }
    >
      Save Changes
    </button>
  </Modal.Footer>
</Modal>
      {/* ══════════════════════════════════════════
          Delete Confirmation Modal
      ══════════════════════════════════════════ */}
      <Modal
        show={deleteModal.show}
        onHide={() => setDeleteModal({ show: false, type: '', id: null, studentName: '' })}
      >
        <Modal.Header closeButton className="sf-modal-header">
          <Modal.Title className="sf-modal-title">Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body className="sf-modal-body">
          <p>
            Are you sure you want to delete this {deleteModal.type} fee record for {deleteModal.studentName}?
            This action cannot be undone.
          </p>
        </Modal.Body>
        <Modal.Footer className="sf-modal-footer">
          <button
            className="sf-btn sf-btn-secondary"
            onClick={() => setDeleteModal({ show: false, type: '', id: null, studentName: '' })}
          >
            Cancel
          </button>
          <button className="sf-btn sf-btn-danger" onClick={handleDeleteFee}>Delete</button>
        </Modal.Footer>
      </Modal>

     {/* ══════════════════════════════════════════
    Toast
══════════════════════════════════════════ */}
<div className={`sf-toast sf-toast-${toast.variant}${toast.show ? ' sf-toast-show' : ''}`}>
  <div className="sf-toast-header">
    <strong className="sf-toast-title">
      {toast.variant === 'success' ? 'Success' : 'Error'}
    </strong>
    <button
      className="sf-toast-close"
      onClick={() => setToast(prev => ({ ...prev, show: false }))}
    >
      ×
    </button>
  </div>
  <div className="sf-toast-body">
    {toast.variant === 'success'
      ? <CheckCircleFill className="sf-toast-icon" />
      : <ExclamationTriangleFill className="sf-toast-icon" />}
    {toast.message}
  </div>
</div>
      {/* ══════════════════════════════════════════
          School Fee Amounts Management Modal
      ══════════════════════════════════════════ */}
      <SchoolFeeAmounts
        show={showFeeAmountsModal}
        onHide={() => setShowFeeAmountsModal(false)}
      />

      <FeeDocumentManager
        formatNumber={formatNumber}
        getSchoolFeeByClass={getSchoolFeeByClass}
        showToastMessage={showToastMessage}
        onActionReady={handleManagerReady}
      />

     {/* ─── Print Password Modal ──────────────────────────────────────── */}
<Modal show={showPrintModal} onHide={() => setShowPrintModal(false)} centered>
  <Modal.Header closeButton className="sf-modal-header">
   <Modal.Title className="sf-modal-title">
  <i className="bi bi-printer-fill" style={{ marginRight: '8px' }} />
  {printMode === 'schoolFeeOnly' ? 'Print School Fee Records' : 'Print Fee Records'}
</Modal.Title>
  </Modal.Header>

  <Modal.Body className="sf-modal-body">

    {/* Class selector */}
    <div className="sf-modal-form-group">
      <label className="sf-modal-label">Select Grade</label>
      <select
        className="sf-modal-input"
        value={printClass}
        onChange={e => { setPrintClass(e.target.value); setPrintPasswordError(''); }}
      >
        <option value="">— Select a grade —</option>
        {['6','7','8','9','10','11','12'].map(cls => (
          <option key={cls} value={cls}>Grade {cls}</option>
        ))}
      </select>
    </div>

    {/* Password field with eye toggle */}
    <div className="sf-modal-form-group">
      <label className="sf-modal-label">Password</label>
      <div className="sf-password-input-wrap">
        <input
          type={showPrintPassword ? 'text' : 'password'}
          className={`sf-modal-input${printPasswordError ? ' is-invalid' : ''}`}
          placeholder="Enter print password"
          value={printPassword}
          onChange={e => { setPrintPassword(e.target.value); setPrintPasswordError(''); }}
          onKeyDown={e => e.key === 'Enter' && handlePrintVerify()}
          autoComplete="off"
          autoFocus
        />
        <button
          type="button"
          className="sf-password-toggle"
          onClick={() => setShowPrintPassword(prev => !prev)}
          tabIndex={-1}
          title={showPrintPassword ? 'Hide password' : 'Show password'}
        >
          <i className={`bi ${showPrintPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'}`} />
        </button>
      </div>
      {printPasswordError && (
        <span className="sf-modal-error">
          <i className="bi bi-exclamation-circle" style={{ marginRight: '4px' }} />
          {printPasswordError}
        </span>
      )}
    </div>

    <div className="sf-staff-alert" style={{ marginBottom: 0 }}>
  <i className="bi bi-info-circle sf-alert-icon" />
  {printMode === 'schoolFeeOnly'
    ? 'Records show school fee paid/outstanding only — miscellaneous fees are excluded.'
    : 'Records include full payment history for school and miscellaneous fees.'}
</div>

  </Modal.Body>

  <Modal.Footer className="sf-modal-footer">
    <button
      className="sf-btn sf-btn-secondary"
      onClick={() => setShowPrintModal(false)}
    >
      <i className="bi bi-x-lg sf-btn-icon" />
      Cancel
    </button>
    <button
      className="sf-btn sf-btn-print"
      onClick={handlePrintVerify}
      disabled={isPrintVerifying}
    >
      {isPrintVerifying
        ? <><span className="sf-spinner" /> Verifying…</>
        : <><i className="bi bi-printer-fill sf-btn-icon" /> Print</>
      }
    </button>
  </Modal.Footer>
</Modal>
       <SchoolFeeGuideModal />
    </>
  );

}

export default SchoolFee;
